import { StateCreator } from 'zustand';

const OVERRIDE_STORAGE_KEY = 'offlineMode.override';

const readOverride = (): boolean | undefined => {
  try {
    const item = localStorage.getItem(OVERRIDE_STORAGE_KEY);
    return item === null ? undefined : item === 'true';
  } catch {
    return undefined;
  }
};

const writeOverride = (value: boolean) => {
  try {
    localStorage.setItem(OVERRIDE_STORAGE_KEY, String(value));
  } catch {
    // ignore write errors
  }
};

export const OFFLINE_MODE_ENV = import.meta.env.VITE_OFFLINE_MODE === 'true';

type State = {
  offlineMode: boolean;
};

type Actions = {
  setOfflineMode: (value: boolean) => void;
};

export type OfflineModeSlice = State & Actions;

export const createOfflineModeSlice: StateCreator<
  OfflineModeSlice,
  [['zustand/immer', never]],
  [],
  OfflineModeSlice
> = (set) => {
  const override = readOverride();
  return {
    offlineMode: override ?? OFFLINE_MODE_ENV,
    setOfflineMode: (value: boolean) =>
      set((state) => {
        writeOverride(value);
        state.offlineMode = value;
      }),
  };
};
